module.exports = __webpack_public_path__ + "img/ada5def.jpg";